import { z } from 'zod';

export const ticketsDashboardSchema = z
  .object({
    category: z
      .enum(['all', 'incident', 'change-request', 'my-request'])
      .default('all'),
  })
  .strict()
  .catch({
    category: 'all',
  });
